export const MULTIDAY_INFINITE = 'MULTIDAY_INFINITE';
export const EBOOK_INFINITE = 'EBOOK_INFINITE';
export const SESSION_QUERY = 'SESSION_QUERY';
export const MULTIDAY_SESSION_DETAILS = 'MULTIDAY_SESSION_DETAILS';
export const MULTIDAY_NOTIFICATION_SESSIONS = 'MULTIDAY_NOTIFICATION_SESSIONS';
export const STREAM_DATA = 'STREAM_DATA';
export const MULTIDAY_SESSION_CERT_TEMPLATE = 'MULTIDAY_SESSION_CERT_TEMPLATE';
export const CHILD_SESSION_QUESTIONS = 'CHILD_SESSION_QUESTIONS';
export const PHOTOBOOTH_TEMPLATE = 'PHOTOBOOTH_TEMPLATE';
